import getNetworkErrorDetails from './get-network-error-details';

export default {
  getNetworkErrorDetails,
};
